import * as React from "react";
import { Show, TabbedForm, TextField, RichTextField, TextInput } from 'react-admin';
import { Typography } from '@mui/material';

export const ShowMSG = () => (
    <Show>
        <TabbedForm toolbar={false}>
            <TabbedForm.Tab label="Информация" >
                От кого: <TextField source="from" />
                Кому: <TextField source="to" /> <br />
                Заголовок: <TextField source="subject" />
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Просмотр" >
                <RichTextField source="body" />
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Оригинал" >
                <TextField source="headers" component="pre" multiline />
            </TabbedForm.Tab>
        </TabbedForm>
    </Show>
);